import React from "react";
import "./Spinner.css";

const Spinner = ({ width, height, borderWidth, borderColor, borderLeftColor}) => {
    return <div 
        className="spinner" 
        style={{
            width: width || "15px",
            height: height || "15px",

            borderWidth: borderWidth || "2px",
            borderStyle: "solid",
            borderColor: borderColor || "rgba(0, 0, 0, 0.2)",
            borderLeftColor:  borderLeftColor || "white"
        }}
    ></div>;
};

export default Spinner;